import React, { useEffect, useState } from "react";
import SalesReportService from "../../../Services/QRCodeServices/ReportServices/SalesReportService";
import { Card, CardBody, Col, Input, Row } from "reactstrap";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import { Triangle } from "react-loader-spinner";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import { Link } from "react-router-dom";
import { formatDateTime } from "../../../Components/Common/FormatDate";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import NumberCommas from "../../../Components/NumberCommas/NumberCommas";

const SalesReportCategory = () => {
  const [allData, setAllData] = useState([]);
  const [loading, setLoading] = useState(false);

  // filters
  const [dateRange, setDateRange] = useState([null, null]);
  const [filterText, setFilterText] = useState("");

  const formatDate = (date) => {
    if (!date) return null;
    return date.toLocaleDateString("en-CA"); // YYYY-MM-DD
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await SalesReportService.categorywise({
        startDate: formatDate(dateRange[0]),
        endDate: formatDate(dateRange[1]),
        searchText: filterText,
      });

      if (response) {
        setAllData(response);
      } else {
        setAllData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setAllData([]);
    } finally {
      setLoading(false);
    }
  };

  // fetch when filters change
  useEffect(() => {
    fetchData();
  }, [dateRange, filterText]);

  // totals
  const totalQuantity = allData.reduce(
    (sum, item) => sum + item.totalQuantity,
    0
  );
  const totalSales = allData.reduce((sum, item) => sum + item.totalSales, 0);

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Sales Report Category" pageTitle="Sales Report" />
      </div>
      <Card>
        <CardBody>
          {/* Filters */}
          <Row className="mb-3">
            <Col md={4}>
              <Flatpickr
                options={{ mode: "range", dateFormat: "Y-m-d" }}
                value={dateRange}
                onChange={(dates) => setDateRange(dates)}
                className="form-control"
                placeholder="Select date range"
              />
            </Col>
          </Row>
          {loading ? (
            <div className="my-3 text-center w-100 d-flex justify-content-center align-content-center align-items-center">
              <Triangle
                visible={true}
                height="80"
                width="80"
                color="#5B71B9"
                ariaLabel="triangle-loading"
              />
              <h5 className="mt-1">Loading...</h5>
            </div>
          ) : (
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th className="table-primary" style={{ width: "60px" }}>
                    SN
                  </th>
                  <th className="table-primary">Category Name</th>
                  <th className="table-primary" style={{ width: "150px" }}>
                    Total Quantity
                  </th>
                  <th className="table-primary" style={{ width: "150px" }}>
                    Total Sales
                  </th>
                </tr>
              </thead>
              <tbody>
                {allData.length > 0 ? (
                  allData.map((item, index) => (
                    <tr key={item.categoryId}>
                      <td>{index + 1}</td>
                      <td>{item.categoryName}</td>
                      <td className="text-end">{item.totalQuantity}</td>
                      <td className="text-end">
                        <NumberCommas number={item.totalSales} />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center">
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
              <tfoot>
                <tr style={{ textAlign: "right" }}>
                  <td colSpan="2" className="fw-bold">
                    Total
                  </td>
                  <td className="fw-bold">{totalQuantity}</td>
                  <td className="fw-bold">
                    <NumberCommas number={totalSales} />
                  </td>
                </tr>
              </tfoot>
            </table>
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default SalesReportCategory;
